import {  useEffect, useRef, useState } from 'react';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-multi-lang';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { useReactToPrint } from 'react-to-print';

import { iPurchaseBillResponse} from '../../services/api/api';

import PrintTemplate from './print_template';
import { arrayHandler } from './tools';
import { useAPI } from '../../services/hoc/useAPI';

interface  iProps {close:Function,data:any,setWait?:Function}
export const PrintPurchaseBill = ({close,data,setWait}:iProps) => {
  const [bill, setBill] = useState<iPurchaseBillResponse | null>(null);
const api = useAPI()
  const t = useTranslation();
  const componenetRef = useRef(null);
  const [pages,setPages]=useState<number[]>([1])
  const handlePrint = useReactToPrint({
    contentRef: componenetRef,
    onAfterPrint: () => close(),
    documentTitle:'PurchaseBill',
  

  });
  useEffect(() => {
    if (bill) handlePrint();
  }, [bill]);
  useEffect(() => {
 
    if (typeof(data) !=='object') {
      api
        .purchaseBill()
        .show({ id: parseInt(data) })
        .then((res: any) => {
         if(setWait) setWait(false)
          if (res.data && res.data.data) {
            if (res.data.data.purchasebilldetail.length>5) {
              let new_arr = new Array(Math.ceil(res.data.data.purchasebilldetail.length/5)).fill(1)
              setPages(pre=>new_arr)}
            setBill(res.data.data)
          }
        });
    }
  }, [data]);
  const handleRow1= (ele:any,index=0)=>{
    if (!ele) return (<></>)
    return (
   
      <TableRow key={index}>

        <TableCell style={{ border: '1px solid #a9a4a4' }}
             className='bolder'>
          {ele.id}
   
        </TableCell>
        <TableCell style={{ border: '1px solid #a7a4a4' }}
             className='bolder'>
         {ele.Total_after_tax}
        </TableCell>
        <TableCell style={{ border: '1px solid #a7a4a4' }}
             className='bolder'>
          {ele.Tax}
          
        </TableCell>
        <TableCell style={{ border: '1px solid #a7a4a4' }}
             className='bolder'>
          {ele.Total}
          
        </TableCell>
        <TableCell style={{ border: '1px solid #a7a4a4' }}
             className='bolder'>
          {ele.Price}
       
        </TableCell>
        <TableCell style={{ border: '1px solid #a7a4a4' }}>
          {ele.description}
         
        </TableCell>
       
        <TableCell style={{ border: '1px solid #a7a4a4' }}
         className='bolder'>
    {ele.sheet_total}
   </TableCell>
  
   <TableCell style={{ border: '1px solid #a7a4a4' }}
        className='bolder'>
    {ele.box_count}
   </TableCell>
   <TableCell style={{ border: '1px solid #a7a4a4' }}
        className='bolder'>
    {ele.sheet_count}
   </TableCell>
   <TableCell style={{ border: '1px solid #a7a4a4' }}
        className='bolder'>
    {ele.area}
   </TableCell>
 
   <TableCell style={{ border: '1px solid #a7a4a4' }}
        className='bolder'>
    {ele.width}
   </TableCell>
   <TableCell style={{ border: '1px solid #a7a4a4' }}
        className='bolder'>
    {ele.length}
   </TableCell>
      
       
      </TableRow>
    )
  }

  const handleRow2=(ele:any,index=0)=>{
    if (!ele) return (<></>)
   return ( <TableRow>
    <TableCell style={{ border: '1px solid #a7a4a4' }}
         className='bolder'>
    {ele.sheet_total}
   </TableCell>
  
   <TableCell style={{ border: '1px solid #a7a4a4' }}
        className='bolder'>
    {ele.box_count}
   </TableCell>
   <TableCell style={{ border: '1px solid #a7a4a4' }}
        className='bolder'>
    {ele.sheet_count}
   </TableCell>
   <TableCell style={{ border: '1px solid #a7a4a4' }}
        className='bolder'>
    {ele.area}
   </TableCell>
 
   <TableCell style={{ border: '1px solid #a7a4a4' }}
        className='bolder'>
    {ele.width}
   </TableCell>
   <TableCell style={{ border: '1px solid #a7a4a4' }}
        className='bolder'>
    {ele.length}
   </TableCell>
   </TableRow>)
  }
  const upperPart =(bill:any)=>{
    return (
      <Grid  container size={12}>
      <div className="standard-height flex w-full flex-end align_center fs-12">
        {/* <input
          value={bill?.name}
          style={{ flex: 1, margin: '0 5px', direction: 'rtl',fontWeight:'bolder' }}
          className='bottom-border'
        /> */}
        <div className='bolder'>{bill?.name}</div>
        <div className="label text-right fs-12">{t('gentlemen')}</div>
      </div>
    </Grid>
    )
  }
  const lowerPart =(bill:any)=>{
    return (
      <>
      <Grid  container paddingX={0} size={6}>
      <div className="standard-height flex  w-full align_center flex-end fs-12">
        {/* <input
            className='bottom-border'
          value={bill?.total}
          style={{ flex: 1, margin: '0 5px', direction: 'rtl' ,fontWeight:'bolder'}}
        /> */}
        <div 
          className='bolder'> {bill?.total}</div>

        <div className="label text-right">{t('total')}</div>
      </div>
    </Grid>
    <Grid size={6} >
      <div className="standard-height flex w-full align_center flex-end fs-12">
        {/* <input
          value={bill?.tax_amount}
          style={{ flex: 1, margin: '0 5px', direction: 'rtl' ,fontWeight:'bolder'}}
          className='bottom-border'
        /> */}
        <div 
          className='bolder'>{bill?.tax_amount}</div>
        <div className="label text-right">{t('tax')}</div>
      </div>
    </Grid>
    <Grid size={6} >
      <div className="standard-height flex w-full flex-end align_center  fs-12">
        {/* <input
            className='bottom-border'
          value={bill?.net_after_tax}
          style={{direction: 'rtl',fontWeight:'bolder' ,textAlign:'right'}}
        /> */}
        <div 
        
          className='bolder'>{bill?.net_after_tax}</div>
        <div className="label text-right"  >{t('net_after_tax')}</div>
      </div>
    </Grid>
    <Grid size={6} >
      <div className="standard-height flex w-full flex-end align_center fs-12">
        {/* <input
            className='bottom-border'
          value={bill?.paid}
          style={{   direction: 'rtl' ,fontWeight:'bolder'}}
        /> */}
        <div 
          className='bolder'>{bill?.paid}</div>
        <div className="label text-right"  >{t('paid')}</div>
      </div>
    </Grid>
    <Grid size={12} >
      <div className="standard-height flex w-full flex-end align_center fs-12">
        {/* <input
            className='bottom-border'
          value={bill?.remains}
          style={{ flex: 1, margin: '0 10px', direction: 'rtl' ,fontWeight:'bolder'}}
        /> */}
        <div 
          className='bolder'>{bill?.remains}</div>
        <div className="label text-right">{t('remains')}</div>
      </div>
    </Grid>
    <Grid size={12} >
      <div className="standard-height flex w-full flex-end align_center fs-12">
        {/* <input
          className='bottom-border'
          value={ bill?.net_after_tax_str}
          style={{ flex: 1, margin: '0 10px', direction: 'rtl',fontWeight:'bolder' }}
        /> */}
        <div 
          className='bolder'>{ bill?.net_after_tax_str}</div>
        <div className="label text-right">{t('written_number')}</div>
      </div>
    </Grid>
    
    <Grid size={12}  justifyContent={'flex-end'}>
      <div className="standard-height flex w-full flex-end align_center fs-12">
        {/* <textarea
          rows={3}
          className='bottom-border'
          value={bill?.note}
          style={{ flex: 1, margin: '0 10px', direction: 'rtl' }}
        /> */}
        <div 
          className='bolder'>{bill?.note}</div> 
        <div className="label text-right">{t('nots')}</div>
      </div>
    </Grid>
    </>
    )
  }


  return (
    <div
    ref={componenetRef as any}
    className="printMe "
     style={{minHeight:pages.length>1?'110vh':'100vh'}}

    >
  
    

  { pages?.map((page,page_index)=>
        <PrintTemplate title_ar='فاتورة مشتريات'
        // title_en='Purchase Voucher'
         hide_title={pages.length>1 && page_index!==0}
        >
        
          
            <Grid  container size={12}  rowGap={3}
            padding={0}>
              
           { pages.length>1 ?
            page_index!==0 ?
            upperPart(bill)
          :null:
          upperPart(bill)
              }
              <Grid size={12} padding={0} >
                <Table >
                  <TableHead>
                    <TableRow >
                      <TableCell style={{ border: '1px dashed black ' }}
                   >
                        <span>تسلسل</span>
                        <br />
                        <span>S.No</span>
                      </TableCell>
                    
                      
                      <TableCell style={{ border: '1px dashed black'  }}
                        >
                        <span> اجمالي بعد الضريبة</span>
                        <br />
                        <span>Totall After Tax</span>
                        
                      </TableCell>
                      <TableCell style={{ border: '1px dashed black'  }}
                        >
                        <span>الضريبة</span>
                        <br />
                        <span>Tax</span>
                      </TableCell>
                      <TableCell style={{ border: '1px dashed black'  }}
                         >
                        <span> اجمالي</span>
                        <br />
                        <span>Totall</span>
                      </TableCell>

                      <TableCell style={{ border: '1px dashed black'  }}
                        >
                        <span>السعر  (ريال)</span>
                        <br />
                        <span>price</span>
                      </TableCell>
                     
                      <TableCell style={{ border: '1px dashed black'  }}>
                        <div
                          style={{
                            display: 'flex',
                            height: '100%',
                            width: '100%',
                            justifyContent: 'space-between',
                            fontSize:'0.8rem'
                          }}>
                          <span >البيان</span>
                          <span >Description</span>
                        </div>
                      </TableCell>
                      <TableCell style={{ border: '1px dashed black'  }}>
                        <span>اجمالي الالواح </span>
                        <br />
                        <span>Total Sheet</span>
                      </TableCell>
                      <TableCell style={{ border: '1px dashed black'  }}>
                        <span> عدد الصناديق </span>
                        <br />
                        <span>Boxes Count</span>
                      </TableCell>
                      <TableCell style={{ border: '1px dashed black'  }}>
                        <span> عدد الالواح </span>
                        <br />
                        <span>Sheets Count</span>
                      </TableCell>
                      <TableCell style={{ border: '1px dashed black'  }}>
                        <span> المساحة الاجمالية </span>
                        <span>Area</span>
                      </TableCell>
                      <TableCell style={{ border: '1px dashed black'  }}>
                        <span>العرض </span>
                        <br />
                        <span>width</span>
                      </TableCell>
                      <TableCell style={{ border: '1px dashed black'  }}>
                        <span>الطول </span>
                        <br />
                        <span>length</span>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  { pages.length>1 ?
               
                  arrayHandler({page_index,step:5,array:bill?.purchasebilldetail?bill?.purchasebilldetail:[]})
                  .map((ele,index)=>handleRow1(ele,index))
               
                    // handleRow1(bill?.purchasebilldetail?.[page_index]):
                    :
                    bill?.purchasebilldetail?.map((ele,index)=>handleRow1(ele,index)

                 
                  )}
                  </TableBody>
                  {/* <TableHead>
                    <TableRow>
                    <TableCell style={{ border: '1px dashed black'  }}>
                        <span>اجمالي الالواح </span>
                        <br />
                        <span>Total Sheet</span>
                      </TableCell>
                      <TableCell style={{ border: '1px dashed black'  }}>
                        <span> عدد الصناديق </span>
                        <br />
                        <span>Boxes Count</span>
                      </TableCell>
                      <TableCell style={{ border: '1px dashed black'  }}>
                        <span> عدد الالواح </span>
                        <br />
                        <span>Sheets Count</span>
                      </TableCell>
                      <TableCell style={{ border: '1px dashed black'  }}>
                        <span> المساحة الاجمالية </span>
                        <br />
                        <span>Area</span>
                      </TableCell>
                      <TableCell style={{ border: '1px dashed black'  }}>
                        <span>العرض </span>
                        <br />
                        <span>width</span>
                      </TableCell>
                      <TableCell style={{ border: '1px dashed black'  }}>
                        <span>الطول </span>
                        <br />
                        <span>length</span>
                      </TableCell>
                 
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  { pages.length>1 ?
                  handleRow2(   bill?.purchasebilldetail?.[page_index])
                  :
                  bill?.purchasebilldetail?.map((ele,index)=>
                  handleRow2(ele,index)
                     )
                    
                    }
                  </TableBody> */}
                </Table>
              </Grid>
              
               
                {pages.length>1 ?
                 page_index===pages.length-1 ?
                lowerPart(bill):null:lowerPart(bill)
                }
            </Grid>
        
          
     

        </PrintTemplate>
    )
  }
        </div>
 
  );
};
